<template lang="pug">
v-timeline#case-guide(dense, align-top)
  v-timeline-item(v-for="(item, i) in items", :key="item.label")
    template(v-slot:icon)
      span.white--text {{ i + 1 }}

    v-card.elevation-2
      v-expansion-panels(flat)
        v-expansion-panel
          v-expansion-panel-header
            div
              .headline(v-text="item.label")
              .subtitle.mt-2(v-text="item.tagline")

          v-expansion-panel-content
            v-tabs(vertical)
              v-tab(v-for="tab in item.tabs", :key="tab.label") {{ tab.label }}

              v-tab-item(v-for="tab in item.tabs", :key="tab.label")
                v-card(flat)
                  v-card-text.black--text
                    v-tabs(v-if="tab.tabs", grow)
                      v-tab(v-for="sub in tab.tabs", :key="sub.label") {{ sub.label }}
                      v-tab-item.pt-4(
                        v-for="sub in tab.tabs",
                        :key="sub.label"
                      )
                        component(v-if="sub.component", :is="sub.component")
                        EmptyComponent(v-else)

                    component(v-else-if="tab.component", :is="tab.component")
                    EmptyComponent(v-else)
</template>

<script>
import obtaining from "./components/Obtaining/data";
import EmptyComponent from "./components/Empty";

export default {
  name: "employer-case-guide",

  components: {
    EmptyComponent,
  },

  data: () => ({
    items: [],
  }),

  created() {
    this.items.push(obtaining);
  },
};
</script>

<style lang="scss" scoped>
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
</style>

<style lang="scss">
#case-guide {
  img {
    width: 100%;
  }

  .v-tabs {
    .v-tabs-bar {
      background: none;
    }

    .v-tab {
      justify-content: flex-start;

      &::before {
        display: none;
      }

      &--active {
        background: #fff;
      }
    }

    .v-tabs-items {
      background: #fff;
      // box-shadow: 0px 2px 10px #00000040;

      .v-tabs {
        .v-tab {
          justify-content: center;

          &::before {
            display: block;
          }

          &--active {
            background: none;
          }
        }

        .v-tabs-items {
          box-shadow: none;
        }
      }
    }
  }

  .v-timeline-item__dot {
    box-shadow: none;
    background: none;
  }

  .v-expansion-panel {
    box-shadow: 0px 2px 10px 2px #00000026;
    background: #f8f9fc;
  }

  .v-card {
    &::before,
    &::after {
      display: none;
    }
  }
}
</style>